export default {
  toasts: {
    load_error: 'Nie udało się załadować stawek opłat',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zapisane',
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  rates: {
    title: 'Marża przetwarzania',
    description:
      'Procent w %, plus opcjonalna kwota stała i minimalna za transakcję. „Dowolna metoda płatności” obowiązuje, gdy nie ma stawki dla konkretnej metody.',
  },
};
